import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=ed36a28c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed36a28c')) {
      api.createRecord('ed36a28c', component.options)
    } else {
      api.reload('ed36a28c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=ed36a28c&", function () {
      api.rerender('ed36a28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26umCrTn3XRce/JS/comp/ErrorMessage.vue"
export default component.exports